'use client'
import Image from 'next/image'
import { useRouter } from 'next/navigation'

import useAuthStore from '@/app/auth/login/store'
import { Dialog, DialogContent } from '@/components/ui/dialog'
// import pateintHero from '@/public/images/patient_login_hero.png'
import loginHero from '@/public/images/login-hero.png'
import mobileLoginHero from '@/public/images/loginImage.png'

import LoginForm from './_components/LoginForm'
import OTPForm from './_components/OTPForm'

const pages = {
  login: LoginForm,
  otp: OTPForm,
} as const

function Login() {
  const router = useRouter()
  const setState = useAuthStore((state) => state.setState)
  const state = useAuthStore((state) => state.state)
  const Step = pages[state] ?? LoginForm

  return (
    <Dialog
      open={true}
      onOpenChange={() => {
        router.back()
        setState('login')
      }}
    >
      <DialogContent
        closePosition='left'
        className={`
          flex min-h-[580px] w-full flex-col items-center
          justify-center bg-white p-0

          lg:max-w-4xl lg:p-0

          md:max-w-3xl

          sm:max-w-xl

          xl:max-w-6xl
        `}
      >
        <div className='flex w-full flex-col md:min-h-[580px] md:flex-row'>
          {/* Left: Form Panel */}
          <div className='flex flex-1 flex-col justify-center bg-white px-4 py-10 md:order-1 md:px-12 md:py-14'>
            <Step />
          </div>

          {/* Hero image: top on mobile, right panel on larger screens */}
          <div className='relative order-first h-56 w-full flex-shrink-0 md:order-2 md:h-auto md:w-[420px]'>
            <Image
              src={mobileLoginHero}
              placeholder='blur'
              fill
              className='rounded-bl-3xl rounded-br-3xl object-cover object-center md:hidden'
              alt='login hero'
              priority
            />
            <Image
              src={loginHero}
              placeholder='blur'
              fill
              className='hidden object-cover object-center md:block'
              alt='login hero'
              priority
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default Login
